import { actions } from "./action";

const initialState = {
  workExperience: {},
  workExperiences: [],
  orgWorkExperiences: [],
  orgWorkExperienceLoading: false,
  orgWorkExperienceSummary: null,
  loadingProgress: null, // NEW: { current: number, total: number, currentUser: string }
  workExperienceError: false,
  orgWorkExperienceError: false,
  error: false,
};

const workExperienceReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_WORK_EXPERIENCE_SUCCESS:
      return {
        ...state,
        workExperience: action.payload,
        workExperienceError: false,
        error: false,
      };
      
    case actions.CREATE_WORK_EXPERIENCE_SUCCESS:
      return {
        ...state,
        workExperiences: [action.payload, ...state.workExperiences],
        workExperienceError: false,
        error: false,
      };
      
    case actions.UPDATE_WORK_EXPERIENCE_SUCCESS:
      const index = state.workExperiences.findIndex(
        (workExp) => workExp.id === action.payload.id
      );
      if (index !== -1) {
        state.workExperiences[index] = action.payload;
      }
      return {
        ...state,
        workExperiences: state.workExperiences,
        workExperienceError: false,
        error: false,
      };
      
    case actions.GET_WORK_EXPERIENCE_TILES_SUCCESS:
      return {
        ...state,
        workExperiences: action.payload,
        workExperienceError: false,
        error: false,
      };

    // ORGANIZATION WORK EXPERIENCE CASES
    case actions.GET_ORG_WORK_EXPERIENCE_REQUEST:
      return {
        ...state,
        orgWorkExperienceLoading: true,
        loadingProgress: null, // Reset progress when starting
        orgWorkExperienceError: false,
        error: false,
      };

    case actions.SET_ORG_WORK_EXPERIENCE_LOADING:
      return {
        ...state,
        orgWorkExperienceLoading: action.payload,
      };

    // NEW: Handle loading progress updates
    case actions.SET_LOADING_PROGRESS:
      return {
        ...state,
        loadingProgress: action.payload,
      };

    case actions.GET_ORG_WORK_EXPERIENCE_SUCCESS:
      return {
        ...state,
        orgWorkExperiences: action.payload,
        orgWorkExperienceSummary: action.summary,
        orgWorkExperienceLoading: false,
        loadingProgress: null, // Clear progress on success
        orgWorkExperienceError: false,
        error: false,
      };

    case actions.CATCH_ERROR:
      if (action.payload?.scope === "org") {
        return {
          ...state,
          orgWorkExperienceError: true,
          orgWorkExperienceLoading: false,
          loadingProgress: null, // Clear progress on error
        };
      }

      if (action.payload?.scope === "general") {
        return {
          ...state,
          workExperienceError: true,
          error: true,
          orgWorkExperienceLoading: false,
          loadingProgress: null, // Clear progress on error
        };
      }

      return {
        ...state,
        workExperienceError: true,
        orgWorkExperienceError: true,
        error: true,
        orgWorkExperienceLoading: false,
        loadingProgress: null, // Clear progress on error
      };
      
    default:
      return state;
  }
};

export default workExperienceReducer;